export default {
  hasTextContent: 'hasTextContent',

  beforeDestroy: function () {
    this._setUnsavedContent(false)
  },

  computed: {
    hasUnsavedContent: function () {
      const textObject = this._get(this.hasTextContent)

      if (textObject) {
        const hasText = this._get(this.hasTextContent, {})
        const values = Object.keys(hasText).map(function (i) {
          return hasText[i]
        })
        const hasTextContent = values.filter((value) => value).length > 0

        return hasTextContent
      }
      return false
    }
  },

  methods: {
    _setUnsavedContent: function (hasUnsaved) {
      const unsavedContentLength = Object.assign({}, this._get(this.hasTextContent, {})) // need a copy to avoid mutating state
      unsavedContentLength[this._uid] = hasUnsaved
      this._set(this.hasTextContent, unsavedContentLength)
    }
  }
}
